import nativeHybrid from '@/util/nativeHybrid'

export function px2vw(px) {
	return px + 'px'
}

export function getSafeInsetTop() {
	return nativeHybrid.getSafeInsetTop()
}

/**
 * 获取屏幕底部安全距离
 * @param hardware 安卓lg容器已经把底部区域留好了,默认返回0,但是如果此参数传true,则返回实际数值
 * @return {number}
 */
export function getSafeInsetBottom(hardware) {
	return nativeHybrid.getSafeInsetBottom(hardware)
}

export function formatMinutes(seconds) {
	function paddingZero(num) {
		if (num < 10) {
			return '0' + num
		}
		return num + ''
	}

	return `${paddingZero(Math.floor(seconds / 60))}:${paddingZero(seconds % 60)}`
}
